import React from 'react';
import { Link, Box } from 'react-limbix-ui';

import { StudyParticipantType } from '@/apollo/types';
import { useModal } from '@/hooks/redux';
import { UnknownAsyncCallback } from '@/types/DataTypes';

type Props = {
  participant: StudyParticipantType;
  onRefetch?: UnknownAsyncCallback;
};
const StudyActions: React.FC<Props> = (props: Props) => {
  const { participant, onRefetch } = props;
  const { showModal } = useModal();
  const render = (
    text: string,
    clickable: boolean,
  ) => {
    if (clickable) {
      return (
        <Link.ButtonLink
          onClick={() => showModal('STUDY_ACTIONS', {
            type: text,
            studyParticipant: participant,
            onRefetch,
          })}
        >
          {text}
        </Link.ButtonLink>
      );
    }
    return (
      <>{text}</>
    );
  };

  return (
    <Box>
      {render(
        'activate',
        participant.canActivate,
      )}
      {' | '}
      {render(
        'complete',
        participant.canComplete,
      )}
      {' | '}
      {render(
        'withdraw',
        participant.canWithdraw,
      )}
      {' | '}
      {render(
        'lost to follow-up',
        participant.canBeLostToFollowup,
      )}
      {' | '}
      {render(
        'drop',
        participant.canBeDropped,
      )}
      {' | '}
      {render(
        'screen fail',
        participant.canScreenFail,
      )}
    </Box>
  );
};

export default StudyActions;
